import ChildParentUserRelationship from '../../dto/kindergarten/ChildParentUserRelationship.js';
import Error from '../../model/Error.js';
import axios from 'axios';

export default class ChildParentUserRelationshipRepository {
    static findForChatsByKindergartenAndSearch(kindergartenId, search) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/chats/child-parent-user-relationships?search=${search}`)
                .then(response => resolve(response.data.data.map(data => ChildParentUserRelationship.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
